import React from 'react';
import { Tabs, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Select from '../Controls/Select/Select';

import styles from './Tabs.module.css';
import { useHistory } from 'react-router-dom';
import { FEATURE_FLAGS_NAMES, LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';
import { SYSTEM_MODE_HIDDEN_VIEWS } from '@silverfort-nodelibs/common/utils/system-mode-config';
import useFeature from '../../hooks/featureFlags/useFeature';

const SettingsTabs = ({
    category,
    fields,
    visibleFields,
    selectedTab,
    setSelectedTab,
    dirtyTabs,
    invalidTabs,
    isFiltered,
    setShowFilterModal,
    tabButton
}) => {
    const systemMode = useFeature(FEATURE_FLAGS_NAMES.SystemMode);
    let availableTabs = Object.values(fields).filter(
        (subcategory) =>
            visibleFields[subcategory.id] &&
            !SYSTEM_MODE_HIDDEN_VIEWS[LAYOUT_TABS.SYSTEM_SETUP.ID][systemMode]?.tabs.has(subcategory.id)
    );
    const selectedTabIsVisible = availableTabs.some((tab) => tab.id === selectedTab);
    const history = useHistory();

    const tabsClasses = makeStyles({
        root: {
            borderBottom: '1px solid #ccc',
            minHeight: '40px',
            fontSize: 'big'
        },
        indicator: {
            display: 'flex',
            backgroundColor: '#188ded',
            height: '1px'
        },
        invalidIndicator: {
            display: 'flex',
            backgroundColor: '#ff3c3c',
            height: '1px'
        }
    })();

    const tabClasses = makeStyles({
        root: {
            textTransform: 'none',
            fontSize: '18px',
            fontFamily: 'Saira',
            fontWeight: 500,
            minWidth: '120px',
            maxWidth: '300px',
            minHeight: '40px',
            letterSpacing: 'normal',
            padding: '0 10px'
        },
        selected: {
            fontWeight: 600
        }
    })();

    const noResults = availableTabs.length === 0;
    const showOnlyFilterBtn = noResults && setShowFilterModal;
    if (!selectedTabIsVisible && !showOnlyFilterBtn) {
        return tabButton ? tabButton : null;
    }

    if (category.SORT_TABS) {
        availableTabs = availableTabs.sort((first, second) => {
            return first.name > second.name ? 1 : -1;
        });
    }

    const setTab = (selectedTab) => {
        if (noResults) {
            return;
        }
        setSelectedTab(selectedTab);
        history.push(`/Settings/${category.NAME}#${selectedTab}`);
    };

    const selectedTabInvalid = invalidTabs.includes(selectedTab);

    let tabsContent = <div />;
    let selectContent = <div />;

    if (!showOnlyFilterBtn) {
        tabsContent = (
            <Tabs
                value={selectedTab}
                onChange={(event, value) => {
                    setTab(value);
                }}
                classes={{
                    root: tabsClasses.root,
                    indicator: selectedTabInvalid ? tabsClasses.invalidIndicator : tabsClasses.indicator
                }}
                variant="scrollable">
                {availableTabs.map((subcategory) => {
                    const invalid = invalidTabs.includes(subcategory.id);
                    const dirty = dirtyTabs.includes(subcategory.id);
                    return (
                        <Tab
                            label={
                                <div className={styles.tabLabel}>
                                    {subcategory.name && (
                                        <span
                                            className={`${styles.tabName} ${
                                                invalid || dirty ? styles.tabNameWithDot : ''
                                            }`}>
                                            {subcategory.name}
                                        </span>
                                    )}
                                    {invalid && <span className={styles.invalidDot}></span>}
                                    {!invalid && dirty && <span className={styles.unsavedDot}></span>}
                                </div>
                            }
                            classes={{ root: tabClasses.root, selected: tabClasses.selected }}
                            value={subcategory.id}
                            key={subcategory.id}
                        />
                    );
                })}
            </Tabs>
        );
        selectContent = (
            <Select
                value={selectedTab}
                changed={(fid, val) => {
                    setTab(val);
                }}
                options={availableTabs.map((subcategory) => {
                    return { value: subcategory.id, label: subcategory.name };
                })}
                color="grey"
                header={true}
                searchable={true}
            />
        );
    }
    return (
        <div className={`${styles.tabsRow} ${tabButton ? styles.buttonRow : ''}`}>
            {tabsContent}
            {tabButton}
            {selectContent}
            {setShowFilterModal && (
                <div className={isFiltered ? styles.filterButton : styles.notFilterButton} onClick={setShowFilterModal}>
                    <i className={`fa fa-filter`} />
                </div>
            )}
        </div>
    );
};

export default React.memo(SettingsTabs);
